import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import content from '@/data/homepageContent.json';
import { CTA_BTN_CLASS } from './HomeSections';

// 4 категории — воздушные вертикальные карточки, всё по центру.
// Фон насыщеннее общего TINT_BG_CLASS (#C7E9FC вместо #DBEFFD/85) — эта зона
// должна явно отделяться от белой зоны с натальной картой над ней, а не
// сливаться с ней в один бледный переход.
export default function CategoriesBlock() {
  const navigate = useNavigate();
  return (
    <section className="bg-accent-cta-150 pt-3 pb-3 px-4" data-testid="categories-block">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {content.categories.map((cat) => (
            <div
              key={cat.slug}
              data-testid={`category-card-${cat.slug}`}
              className="group flex flex-col items-center text-center bg-white border-2 border-accent-cta-300 rounded-xl shadow-sm hover:shadow-lg hover:-translate-y-0.5 transition-all overflow-hidden"
            >
              <div className="w-full h-[160px] flex items-center justify-center bg-accent-cta-50/40 overflow-hidden">
                {/* width/height обязательны: без них браузер до загрузки
                    картинки не знает её размеров, ставит бокс 0x0 и
                    раскладывает карточку заново уже по факту загрузки —
                    это и давало лабораторный CLS. 240x160 — не размер файла
                    (он 1536x1024), а ровно тот бокс, который картинка
                    занимает сейчас: max-h-full упирает её в 160px высоты
                    контейнера, при 3:2 это 240px ширины. Поэтому размеры
                    только резервируют место, а вид не меняют. */}
                <img
                  src={cat.image}
                  alt={cat.title}
                  width="240"
                  height="160"
                  className="max-w-full max-h-full object-contain transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="flex flex-col items-center flex-1 w-full px-3 py-1 text-center">
                <h3 className="text-sm md:text-base font-heading font-extrabold text-slate-900 leading-tight mb-0.5 uppercase tracking-wide">
                  {cat.title}
                </h3>
                <p className="text-xs text-slate-600 leading-snug mb-1 line-clamp-2 flex-1">
                  {cat.description}
                </p>
                <Button
                  size="sm"
                  className={`w-full max-w-[220px] text-xs md:text-sm h-9 ${CTA_BTN_CLASS}`}
                  onClick={() => navigate(cat.path)}
                  data-testid={`category-cta-${cat.slug}`}
                >
                  ПЕРЕЙТИ
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
